export const processedProfileSuggestions = (suggestions) => {
  const {
    bio,
    location,
    education,
    pastRoles,
    functionalAreas,
    industries,
    productTechnologies,
    stagesOfDevelopments,
    therapeuticAreas,
  } = suggestions;

  const data = {
    bio: bio.accepted && bio.bio ? bio.bio : '',
    location: location.accepted && location.location ? location.location : '',
    education: education.filter((e) => e.accepted).map((e) => ({
      consultant_profile_id: e.education.consultantProfileId,
      degree_id: e.education.degree ? e.education.degree.value : null,
      area_of_study: e.education.areaOfStudy,
      school: e.education.school,
      start_year: e.education.startDate ? new Date(e.education.startDate) : null,
      end_year: e.education.endDate ? new Date(e.education.endDate) : null,
    })),
    past_roles: pastRoles.filter((pr) => pr.accepted).map((pr) => ({
      company_name: pr.pastRole.companyName,
      consultant_profile_id: pr.pastRole.consultantProfileId,
      current: pr.pastRole.current,
      description: pr.pastRole.description,
      end_date: pr.pastRole.endDate,
      start_date: pr.pastRole.startDate,
      title: pr.pastRole.title,
      company_id: pr.pastRole.companyId,
    })),
  };
  const tags = [
    { id: 'functionalAreas', name: 'functional_areas', data: functionalAreas },
    { id: 'industries', name: 'industries', data: industries },
    { id: 'productTechnologies', name: 'product_technologies', data: productTechnologies },
    { id: 'therapeuticAreas', name: 'therapeutic_areas', data: therapeuticAreas },
    { id: 'stagesOfDevelopments', name: 'stages_of_development', data: stagesOfDevelopments },
  ];
  for (let i = 0; i < tags.length; i += 1) {
    const tag = tags[i];
    data[tag.name] = tag.data.filter((t) => t.accepted).map((t) => (
      { ...t[tag.id.slice(0, tag.id.length - 1)] }
    ));
  }

  return Object.fromEntries(Object.entries(data).filter((entry) => entry[1].length));
};

export default processedProfileSuggestions;
